export interface FloorRow {
  label: string
  value: string
}
export interface FloorData {
  id: string
  tab: string
  title: string
  area: string
  rows: FloorRow[]
  ceilingHeight: string
  planLabel: string
  planImage: string
  footnote?: string
}
export const floors: FloorData[] = [
  {
    id: 'ground',
    tab: 'Ground',
    title: 'Ground Floor Area',
    area: '220 SQM',
    ceilingHeight: '3.00 M',
    planLabel: 'Ground Floor Plan',
    planImage:
      'https://cdn.magicpatterns.com/uploads/wdJ1TbPn8zPYLNWoqd8iZk/4.png',
    footnote: '*Not included in total ground floor area',
    rows: [
      {
        label: 'Living, Dining and Main Kitchen',
        value: '140 SQM',
      },
      {
        label: 'Guest Bedroom / Den',
        value: '17.20 SQM',
      },
      {
        label: 'Guest Bedroom T&B',
        value: '7.20 SQM',
      },
      {
        label: 'Powder Room',
        value: '6.25 SQM',
      },
      {
        label: 'Porch / Lanai',
        value: '6.20 SQM',
      },
      {
        label: 'Garden*',
        value: '190 SQM',
      },
    ],
  },
  {
    id: 'second',
    tab: 'Second',
    title: 'Second Floor Area',
    area: '200 SQM',
    ceilingHeight: '4.50 M',
    planLabel: 'Second Floor Plan',
    planImage:
      'https://cdn.magicpatterns.com/uploads/2NSM7M2D3BmiPcpLW9XkJW/5.png',
    rows: [
      {
        label: 'Bedroom 1',
        value: '24.50 SQM',
      },
      {
        label: 'Bedroom 1 T&B',
        value: '7.50 SQM',
      },
      {
        label: 'Bedroom 2',
        value: '18.50 SQM',
      },
      {
        label: 'Bedroom 2 T&B',
        value: '8 SQM',
      },
      {
        label: 'Master Bedroom with Balcony',
        value: '63 SQM',
      },
      {
        label: 'Walk In Closet',
        value: '15 SQM',
      },
      {
        label: 'Master T&B',
        value: '12.50 SQM',
      },
      {
        label: 'Hallway',
        value: '20.50 SQM',
      },
    ],
  },
  {
    id: 'basement',
    tab: 'Basement',
    title: 'Basement Floor Area',
    area: '250 SQM',
    ceilingHeight: '2.90 M',
    planLabel: 'Basement Floor Plan',
    planImage:
      'https://cdn.magicpatterns.com/uploads/ta23ybRuz9toepmUr8UhNs/6.png',
    rows: [
      {
        label: 'Multipurpose',
        value: '48.30 SQM',
      },
      {
        label: 'Multipurpose T&B',
        value: '7.10 SQM',
      },
      {
        label: "Maid's Room",
        value: '21.10 SQM',
      },
      {
        label: "Maid's Room T&B",
        value: '3.50 SQM',
      },
      {
        label: 'Service Kitchen',
        value: '13.17 SQM',
      },
      {
        label: 'Foyer',
        value: '19.40 SQM',
      },
      {
        label: "Driver's Room",
        value: '8.40 SQM',
      },
      {
        label: "Driver's Room T&B",
        value: '3.10 SQM',
      },
      {
        label: 'Pump Room',
        value: '5.00 SQM',
      },
    ],
  },
]
